/**
 * ЭТО КОПИЯ ПРОДУКТА НА МАШИНЕ, А НЕ ПРОДУКТ. Отдельный модуль без единого импорта: App.tsx решает по
 * нему, грузить ли плашку Local (utils/devUnlock.ts), ещё до рендера — и если бы проверка жила в
 * devUnlock.ts, первый бандл каждого посетителя прода тянул бы с ней весь код разблокировки и записи
 * покупок (ревью, 2026-09-23).
 *
 * ГЕЙТ — ИМЯ ХОСТА, А НЕ СБОРКА, как у аналитики (analyticsGate.ts): `:8787` отдаёт продовую сборку.
 * Только loopback: хост из локальной сети (192.168.*) — уже чужая машина. Браузер нормализует имя до
 * сравнения, поэтому `localhost.evil.com`, `app.localhost`, `0.0.0.0` сюда не проходят, а `127.1` и
 * `[0:0:0:0:0:0:0:1]` проходят — это и есть loopback.
 */
const LOCAL_HOSTS = ['localhost', '127.0.0.1', '::1', '[::1]']

export const onLocalHost = (): boolean =>
  typeof window !== 'undefined' && LOCAL_HOSTS.includes(window.location.hostname)
